<template>
  <div>
    <section
      style="
    height: 100px; padding-top: 20px; text-align: left;"
    >
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <h1>{{ env }}Payment Request</h1>
          </div>
        </div>
      </div>
    </section>

    <div v-if="paymentLoaded">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <p style="text-align: left;">
              You have been requested to make a payment to your account. Please
              make the payment using the form below
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6" id="payment-element">
            <h2>Make Payment</h2>
            <div
              class="block tabular"
              style="padding: 20px; position: relative;"
            >
              <p>
                Add credit to your account. Enter the amount below then continue
                to securely enter your card details
              </p>

              <PaymentChoice
                ref="paymentChoice"
                gtag-reference="PrePayRequest"
                :debt-percent="payment.debt_percent"
                :allow-further-payment="false"
                :ignore-capture="true"
                @complete="resetPayment"
              ></PaymentChoice>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentChoice from "@/views/Components/Payment/PaymentChoice.vue";

export default {
  name: "payment",
  components: { PaymentChoice },
  props: ["id"],
  data() {
    return {
      paymentLoading: false,
      payment: {},
      paymentComplete: false,
      paymentLoaded: false
    };
  },
  computed: {
    env() {
      return process.env.VUE_APP_ENV;
    }
  },
  created() {
    this.$store.dispatch("loaderCancel");
    this.fetchData();
  },
  methods: {
    resetPayment() {
      this.requestAmount = "";
      this.paymentComplete = false;
    },
    fetchData() {
      const title = "Fetching Payment";
      const subtitle = "Getting payment details";
      this.$store.dispatch("loaderInitiate", { title, subtitle });

      const reference = this.id;

      this.$store
        .dispatch("getPayment", { reference })
        .then(response => {
          this.payment = response.data;
          this.paymentLoaded = true;

          this.stripeElementsSecret = response.data.secret;

          this.$nextTick(() => {
            this.$refs.paymentChoice.loadPayment(
              response.data.secret,
              this.payment.amount
            );
          });
        })
        .catch(() => {
          this.$swal({
            title: "Invalid Request",
            text:
              "Invalid link for payment. If this problem persists please contact us",
            type: "error",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "OK"
          }).then(result => {
            if (result.value) {
              this.$router.push("/login");
            }
          });
        })
        .finally(() => {
          this.$store.dispatch("loaderCancel");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 1.6rem !important;
  text-align: left !important;
  margin-bottom: 10px !important;
  padding-left: 10px;
  margin-top: 20px;
}

.row {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
